import React from "react";
import Reveal from "../components/Reveal";
import { useSite } from "../context/SiteContext";

export const Teachers = ({ standalone = false }) => {
    const { content } = useSite();
    const list = content.teachers || [];

    return (
        <section
            id="teachers"
            data-testid="teachers-section"
            className={`relative bg-[#FAFAFA] ${standalone ? "pt-36 pb-28" : "py-24 lg:py-32"}`}
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-14">
                    <Reveal className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#14545E]/10 text-[#14545E] text-[11px] tracking-[0.2em] uppercase mb-5">
                            Müəllim heyəti
                        </div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A1F3D] leading-[1.05]">
                            Təcrübə və <span className="text-[#14545E]">sevgi</span> ilə.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="lg:col-span-5 flex items-end">
                        <p className="text-neutral-600 text-base lg:text-lg leading-relaxed">
                            Hər müəllimimiz öz sahəsində peşəkar — sənədli təcrübə, beynəlxalq sertifikatlar və ən əsası şagirdə fərdi yanaşma.
                        </p>
                    </Reveal>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
                    {list.map((t, i) => (
                        <Reveal key={t.id || i} delay={i * 0.08}>
                            <div
                                data-testid={`teacher-card-${i}`}
                                className="group cursor-default"
                            >
                                <div className="relative overflow-hidden bg-white rounded-2xl aspect-[3/4] mb-5 border border-neutral-200 shadow-sm">
                                    <img
                                        src={t.image}
                                        alt={t.name}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-[#0A1F3D] via-[#0A1F3D]/70 to-transparent text-white">
                                        <div className="text-[10px] tracking-[0.2em] uppercase text-[#7FB8C6] mb-1">
                                            {t.role}
                                        </div>
                                        <h3 className="font-serif-display text-xl">
                                            {t.name}
                                        </h3>
                                    </div>
                                </div>
                                <p className="text-sm text-neutral-600 leading-relaxed">
                                    {t.bio}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Teachers;
